import Head from 'next/head';
import ImageBanner from '../components/ImageBanner';
import BannerTitle from '../components/BannerTitle';
import Image from 'next/legacy/image';

import styles from './franchising.module.css';
import idealPartner from '../public/assets/images/ideal_partner.png';
import Link from 'next/link';

const Franchising = () => {
  return <>
    <Head>
      <title>Shaking Crab | Franchising</title>
    </Head>
    <ImageBanner image={'https://cdn.shakingcrab.com/website/images/franchising_header.jpg'}>
      <BannerTitle title='Franchising' />
    </ImageBanner>
    <div
      className={`${styles.content_block} ${styles.light_yellow_bg}`}>
      <div
        className={styles.side_content}>
        <div
          className={styles.intro_icon}>
          <i className={`icon-sc-arrow-target`}/>
        </div>
        <div
          className={styles.intro_title}>
            Our Mission
        </div>
        <div
          className={styles.intro_text}>
          {/* eslint-disable-next-line max-len */}
          <strong>Our mission</strong> is to spread the love of buttery, garlicky, Cajun seafood throughout the world and focus on the power of food to be <strong>together, in the moment</strong>.</div>
      </div>
      <div
        className={styles.side_content}>
        <div
          className={styles.intro_icon}>
          <i className={`icon-sc-solution`}/>
        </div>
        <div
          className={styles.intro_title}>
            #ShakingRevolution
        </div>
        <div
          className={styles.intro_text}>
          {/* eslint-disable-next-line max-len */}
            Join the #ShakingRevolution and we’ll provide you with a complete business solution to own your business without being alone; Our team will be there to support you every step of the way.</div>
      </div>
    </div>
    <div>
      <div
        className={styles.content_title}>
            FRANCHISE WITH SHAKING CRAB
      </div>
      <div
        className={styles.content_block}>
        <div
          className={styles.side_content}>
          <p
            className={styles.para_text}>
            {/* eslint-disable-next-line max-len */}
            A SHAKING CRAB® Franchise offers the opportunity to build a business, shape a culture and invest in a better future for your community.
          </p>
          <p
            className={styles.para_text}>
            {/* eslint-disable-next-line max-len */}
                We are seeking franchise candidates across the United States to spread the love of the Cajun Seafood Boil experience.
          </p>
        </div>
        <div
          className={styles.side_content}>
          <p
            className={styles.para_text}>
            {/* eslint-disable-next-line max-len */}
                SHAKING CRAB®&apos;s success is directly tied to the passion and drive that our Franchisees bring to their local businesses. That&apos;s why we take great care in selecting who we partner with, getting to know candidates in a selection process that ensures that a franchise will be a great fit.
          </p>
        </div>
      </div>
    </div>
    <div
      className={styles.light_yellow_bg}>
      <div
        className={styles.content_title}>
          IS SHAKING CRAB THE RIGHT FRANCHISE FOR YOU
      </div>
      <div
        className={styles.content_block}>
        <div
          className={styles.side_content}>
          <div
            className={styles.para_text}>
            {/* eslint-disable-next-line max-len */}
                Franchising is not an opportunity for passive financial investment. SHAKING CRAB is a hands-on, life investment to own where you are accountable to the growth of your team so that they can promote the upbeat atmosphere and culture for our customers. It often requires long hours and leading a team of mostly young, hourly-paid and tipped employees. It’s hard work – but it’s exceedingly rewarding.
          </div>
        </div>
        <div
          className={styles.side_content}>
          <div
            className={styles.para_text}>
            {/* eslint-disable-next-line max-len */}
            <ul>
              <li>
                  Customer-first mentality
              </li>
              <li>
                  A passion for food
              </li>
              <li>
                  Strong sales and marketing skills
              </li>
              <li>
                {/* eslint-disable-next-line max-len */}
                  Minimum of 2 years of experience in the restaurant industry, preferably in a management role
              </li>
              <li>
                  Familiar with local market
              </li>
              <li>
                  Discipline, Integrity, and Humility
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div
        className={styles.content_title}>
            BRAND REQUIREMENTS
      </div>
      <div
        className={styles.content_block}>
        <div
          className={styles.side_content}>
          <div
            className={styles.para_text}>
            {/* eslint-disable-next-line max-len */}
            <ul>
              <li>Licensing contract agreement with established suppliers</li>
              <li>Clover Point of Sale System</li>
              {/* eslint-disable-next-line max-len */}
              <li>Base menu must be followed before adding specials menu items</li>
            </ul>
          </div>
        </div>
        <div
          className={styles.side_content}>
          <div
            className={styles.side_image}>
            <Image src={idealPartner} alt='Ideal Partner' />
          </div>
        </div>
      </div>
    </div>
    <div
      className={styles.light_yellow_bg}>
      <div
        className={styles.content_title}>
          WHAT CAN YOU EXPECT AS A SHAKING FRANCHISEE
      </div>
      <div
        className={styles.content_block}>
        <div
          className={styles.side_content}>
          <p
            className={styles.para_title}>
              Investment
          </p>
          <p
            className={styles.para_text}>
            {/* eslint-disable-next-line max-len */}
              While the licensing fee for a Shaking Crab location is only $25,000, the total investment can range from $300k to $800k to acquire, renovate, and provide for initial operating costs)
          </p>
          <p>&nbsp;</p>
          <p
            className={styles.para_title}>
              Risks
          </p>
          <p
            className={styles.para_text}>
            {/* eslint-disable-next-line max-len */}
            Franchisees are running a complex business and in charge of all aspects of the restaurant. Although Shaking Crab provides guidance towards a successful franchise, the ultimate profitability of the franchise relies on their hard work, leadership, and business acumen. Success is not, however, guaranteed.
          </p>
        </div>
        <div
          className={styles.side_content}>
          <p
            className={styles.para_title}>
              Service-Minded
          </p>
          <p
            className={styles.para_text}>
            {/* eslint-disable-next-line max-len */}
              Shaking Crab is in the restaurant industry focused on the guest experience.  Franchisees must be passionate about serving great food and providing exceptional hospitality and energy to make each experience memorable for our guests.
          </p>
          <p>&nbsp;</p>
          <p
            className={styles.para_title}>
              Selection Process
          </p>
          <p
            className={styles.para_text}>
            {/* eslint-disable-next-line max-len */}
              Competitive candidates will show evidence of financial integrity, humility and a willingness to learn, proven business leadership and acumen, an entrepreneurial spirit, a growth mindset, and strong character.
          </p>
        </div>
      </div>
    </div>
    <div
      className={styles.light_yellow_bg}>
      <div
        className={styles.apply_button}>
        <Link
          passHref
          href={`https://docs.google.com/forms/d/e/1FAIpQLScPaygxnUehLH0osUXTc87taYvoX5jO31eltR-czE1vJe7BlQ/viewform`}
          target={'_blank'}
          className={`custom__button`}>

                  APPLY NOW!

        </Link>
      </div>
    </div>
  </>;
};

export default Franchising;
